import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UpdateManualDataModel } from 'src/app/models/upload/update_manual_data.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';
import { UpdateManualDataService } from 'src/app/service/update-manual-data.service';

@Component({
  selector: 'app-update-adjustment-results',
  templateUrl: './update-adjustment-results.component.html',
  styleUrls: ['./update-adjustment-results.component.css']
})
export class UpdateAdjustmentResultsComponent implements OnInit {
  public adjustmentResultsData: UpdateManualDataModel[] = [];
  public adjustmentResultsExcelData: UpdateManualDataModel[] = [];
  public addAdjustment = new UpdateManualDataModel();
  public kpisList: UpdateManualDataModel[] = [];
  public complansList: UpdateManualDataModel[] = [];
  public calrunidsList: UpdateManualDataModel[] = [];

  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  resHeadder: string = 'Uploaded Adjustments';
  actions: any;
  actionButtons: any;
  buttons: Buttons[] = [];

  IsmodelShow: boolean = false;
  exportExcelUserData: UpdateManualDataModel[] = [];
  isAccessDisabled: boolean = false;
  errorMessage: string;

  constructor(private updateManualDataService: UpdateManualDataService, private komFeedService: KomFeedService, private commissionService: CommissionService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.getResults();
    this.initializeColumns();
    this.initializeExcelHeaders();

    console.log(this.updateManualDataService.updateManualDataModel);
    // this.adjustmentResultsData = this.updateManualDataService.updateManualDataModel;
    this.getCalRunIds();
    this.getCommPlans();
    this.getKpis();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.uploadedAdjustmentsResults;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.adjustmentResultsExcelData));
    console.log(this.exportExcelUserData);
    for (let js of this.exportExcelUserData) {
      delete js.id;
      delete js.commission_period;
      delete js.kpi;
    }
    //console.log(this.exportExcelUserData);
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelUserData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'Uploaded Adjustments',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  getResults() {
    if (this.updateManualDataService.updateManualDataModel) {
      this.updateManualDataService.searchAdjustmentResults(this.updateManualDataService.updateManualDataModel).subscribe((data: UpdateManualDataModel[]) => {
        this.adjustmentResultsData = data;
        this.adjustmentResultsExcelData = JSON.parse(JSON.stringify(data));
        console.log(this.adjustmentResultsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    }
  }

  public saveAdjustment(kpiForm: NgForm): void {

    //this.addAdjustment.cre = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    console.log(this.addAdjustment);


    this.updateManualDataService.saveAdjustment(this.addAdjustment).subscribe((data: UpdateManualDataModel) => {
      this.notificationService.sendNotification(NotificationType.SUCCESS, 'Inserted Successfully');
      this.close(kpiForm, 'closeAddKPIButton');

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });

  }


  close(form: NgForm, id: string) {
    form.reset();
    document.getElementById(id).click();
  }

  public getCalRunIds(): void {
    console.log("getActiveCorps called");
    this.updateManualDataService.getCalRunIds().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.calrunidsList = response;
        this.calrunidsList = this.calrunidsList.filter((v, i) => this.calrunidsList.findIndex(item => item.calrunid == v.calrunid) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getCommPlans(): void {
    console.log("getCommPlans called");
    this.updateManualDataService.getCommPlans().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.complansList = response;
        // console.log(this.complansList);
        this.complansList = this.complansList.filter((v, i) => this.complansList.findIndex(item => item.commplanid == v.commplanid) === i);
        // console.log(this.complansList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getKpis(): void {
    console.log("getKpis called");
    this.updateManualDataService.getKpis('Adjustments').subscribe(
      (response: UpdateManualDataModel[]) => {
        this.kpisList = response;
        //console.log(this.kpisList);
        this.kpisList = this.kpisList.filter((v, i) => this.kpisList.findIndex(item => item.kpiid == v.kpiid) === i);
        //console.log(this.kpisList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getAdjustmentsById(id: any, empname: string) {
    console.log(id);
    this.updateManualDataService.getAdjustmentsById(id).subscribe
      ((data: UpdateManualDataModel) => {
        console.log(JSON.stringify(data));
        this.updateManualDataService.editAdjustmentsModel = data;
        this.updateManualDataService.editAdjustmentsModel.empname = empname;
        console.log(this.updateManualDataService.editAdjustmentsModel);
        this.router.navigate(['/update-adjustments-edit']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public deleteAdjustment(id: number): void {
    console.log(id);
    if (confirm("Do you really want to delete?")) {
      this.updateManualDataService.deleteAdjustment(id).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.getResults();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }

  innerRowAction1(row: any) {
    console.log(row.value);
    console.log(row.row.id);


    if (row.value === 'Update') {
      console.log(row.row.empname);
      this.getAdjustmentsById(row.row.id, row.row.empname);
    }
    if (row.value === 'Delete') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      this.deleteAdjustment(row.row.id);
    }

  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    if (action === "Add") {
      document.getElementById(action).click();
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.AdjustmentUpdateColumns;
        //console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-success btn-xs'
      }
    ]
    this.buttons = [

      {
        name: 'Back',
        pagenavigation: 'update-manual-data'
      }
    ]
  }

}
